<template>
  <modal
    v-if="show"
    bodyPadding="0"
    width="100%"
    height="100%"
    bodyOverflow="auto"
    :title="modalTitle"
    @close="checkClose"
    :read-article-url="`https://docs.bemob.com/${$i18n.locale}/campaign-creation-destination-settings`"
  >
    <div class="create-flow__body create-flow">
      <flow-navigation
        ref="flowNavigationRef"
        :form="form"
        v-model:view="view"
        :country-name="countryName"
        :header="header"
        :activeRule="active_rule"
        :formErrors="form_errors"
        :errors-raw="errorsRaw"
        @set-rule="handleChangeRule"
        @set-path="active_path = $event"
        @set-errors="active_path_errors = $event"
        @set-placeholder="rule_placeholder = $event"
        @add-path="addPath"
        @add-rule="addRule"
      ></flow-navigation>

      <flow-settings
        class="flow-wrapper"
        v-if="view === 'settings'"
        :form="form"
        @change-workspace="onChangeWorkspace"
        @change-country="onChangeCountry"
        :errors-dict="errorsDict"
        :disabledWorkspace="disabledWorkspace"
        :workspacesList="workspacesList"
      ></flow-settings>

      <path-settings
        v-if="view === 'path-settings'"
        :key="`${ruleIndex}-${pathIndex}`"
        :rule="active_rule"
        :rule-index="ruleIndex"
        :path="active_path"
        :path-index="pathIndex"
        :form="form"
        :allWorkspaceIds="allWorkspaceIds"
        :errors-dict="errorsDict"
        :errors-raw="errorsRaw"
        @duplicate="duplicatePath"
        @delete="deletePath"
        :offerOptions="offerOptions"
        :landingOptions="landingOptions"
      ></path-settings>

      <rule-settings
        v-if="view === 'rule-settings'"
        :placeholder="rule_placeholder"
        :rule="active_rule"
        :rule-index="ruleIndex"
        @duplicate="duplicateRule"
        @delete="deleteRule"
      ></rule-settings>
    </div>

    <template #footer>
      <section class="justify-space-between align-center xs12 create-flow__footer">
        <div>
          <error-aggregator
            v-model="errors"
            v-model:active="errorsControlActive"
          ></error-aggregator>
        </div>
        <div class="create-flow__footer-actions justify-end align-center">
          <ui-update-info v-if="mode === 'edit'" :data="form"></ui-update-info>
          <ui-button
            :text="itemActions.cancel.title"
            icon="fas fa-times"
            :disabled="itemActions.cancel.disabled"
            @click="itemActions.cancel.click"
          ></ui-button>
          <ui-button
            data-action="save"
            :text="itemActions.save.title"
            icon="fas fa-check"
            button-style="accent"
            :disabled="itemActions.save.disabled"
            :loading="submitLoading"
            @click="itemActions.save.click"
          ></ui-button>
        </div>
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import FlowNavigation from './views/flow-navigation.vue';
import FlowSettings from './views/flow-settings.vue';
import PathSettings from './views/path-settings.vue';
import RuleSettings from './views/rule-settings.vue';
import { computed } from 'vue';
import {
  useFlowDialog,
  type FlowDialogData,
} from './useFlowDialog';

const props = withDefaults(
  defineProps<{
    data?: FlowDialogData;
  }>(),
  {
    data: () => ({}),
  },
);

const emit = defineEmits<{
  close: [];
  refresh: [];
}>();

const mode = computed(() => props.data.mode ?? 'create');

const {
  show,
  view,
  form,
  active_path,
  active_rule,
  rule_placeholder,
  active_path_errors,
  form_errors,
  submitLoading,
  offerOptions,
  landingOptions,
  errorsRaw,
  errors,
  errorsControlActive,
  errorsDict,
  flowNavigationRef,
  workspacesList,
  header,
  modalTitle,
  countryName,
  ruleIndex,
  pathIndex,
  allWorkspaceIds,
  disabledWorkspace,
  itemActions,
  checkClose,
  handleChangeRule,
  addPath,
  deletePath,
  duplicatePath,
  addRule,
  duplicateRule,
  deleteRule,
  onChangeWorkspace,
  onChangeCountry,
} = useFlowDialog(
  mode.value,
  () => props.data,
  () => emit('close'),
  () => emit('refresh'),
);
</script>

<style lang="scss">
  @import '@/styles/dialogs/flow-form-dialog';
</style>

<style lang="scss" scoped>
.create-flow {
  display: flex;
}

.update-info {
  display: flex;

  :deep(.name) {
    max-width: 250px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

@media (max-width: 900px) {
  .update-info {
    display: none;
  }
}
</style>
